import App from 'app/app.js';
import 'app/action/ResetJobAction.js';
import 'app/action/SessionTimeoutAction.js';

function RouteCacheService(LogoutSuccessAction, SessionTimeoutAction, $rootScope, $location) {
  var tempCache = { cache: null },
    maxRoutesToMaintainCache = 0,
    numberOfRoutes = 0;

  this.set = function (objectToCache, maxHops) {
    maxRoutesToMaintainCache = 0;
    if (!!maxHops) {
      maxRoutesToMaintainCache = maxHops;
    }
    tempCache = { fromRoute: $location.path(), toRoute: null, cache: objectToCache };
    numberOfRoutes = 0;
  };

  this.get = function () {
    var cache = tempCache.cache;

    tempCache = { cache: null };
    return cache;
  };

  this.clear = function () {
    tempCache = { cache: null };
  };

  $rootScope.$on('$routeChangeStart', function (event, next, current) {
    if (tempCache.cache !== null) {
      var flattenPathAndKeys = function (route) {
        var currentRoute = route.$$route.originalPath; //   /addon-detail/:sku/:someOther
        var queryParamsKeys = route.$$route.keys; //   [{name:'sku'}, {name: 'someOther'}]
        var queryParamsValues = route.pathParams; //   {sku:'12345', someOther:'ABC'}

        R.forEach(function (paramKey) {
          currentRoute = currentRoute.replace(':' + paramKey.name, queryParamsValues[paramKey.name]);
        }, queryParamsKeys);
        return currentRoute;
      };

      var cur = flattenPathAndKeys(current);
      var nxt = flattenPathAndKeys(next);

      if (tempCache.toRoute === null) {
        tempCache.toRoute = nxt;
      }
      numberOfRoutes = numberOfRoutes + 1;
      if (
        maxRoutesToMaintainCache === 0 &&
        !(
          (nxt === tempCache.toRoute && cur === tempCache.fromRoute) ||
          (cur === tempCache.toRoute && nxt === tempCache.fromRoute)
        )
      ) {
        tempCache = { cache: null };
      } else if (
        maxRoutesToMaintainCache > 0 &&
        numberOfRoutes > maxRoutesToMaintainCache &&
        nxt !== tempCache.fromRoute
      ) {
        tempCache = { cache: null };
      }
    }
  });

  LogoutSuccessAction.register(this.clear.bind(this));
  SessionTimeoutAction.register(this.clear.bind(this));
}

App.service('RouteCacheService', [
  'LogoutSuccessAction',
  'SessionTimeoutAction',
  '$rootScope',
  '$location',
  RouteCacheService
]);
